import { FC } from 'react';

import styles from './NoSessionMessage.module.scss';

export const NoSessionMessage: FC = () => {
  const message = 'Everything is ready for you to get started.';

  return <div className={styles.emptyStateMessage}>{message}</div>;
};
